import { FC } from 'react'

import { getQualityBandColor } from 'partner360/components/qualityIndicator'

import { formatCockpitScore, getAchievementScoreBand, toBadgeScore } from '../../../lib'

import styles from './AchievementScoreBadge.module.scss'

interface IAchievementScoreBadgeProps {
  score: number | null
}

/** The Achievement score pill for a Revenue & SOB group header — the same shape as the Plan
 *  Quality pill and the same band colors, on the Achievement score's own thresholds. A pill always
 *  reads a number: `toBadgeScore` turns a missing score into the 0 it amounts to, so both the text
 *  and the band come off a real value rather than leaving a `--` on a neutral gray pill. */
export const AchievementScoreBadge: FC<IAchievementScoreBadgeProps> = ({ score }) => {
  const value = toBadgeScore(score)
  const band = getAchievementScoreBand(value)

  return (
    <span
      className={styles.badge}
      style={{ backgroundColor: band ? getQualityBandColor(band) : undefined }}
    >
      {formatCockpitScore(value)}
    </span>
  )
}

AchievementScoreBadge.displayName = 'AchievementScoreBadge'
